function transferDataTableFilters(){
    const desktopWrapper = $('.js-dt-filters-container');
    const mobileWrapper = $('.js-dt-filters-mobile-wrapper');

    if(window.matchMedia(`(min-width: 600px)`).matches){
        $('.js-select-filter-wrap').each(function(){
            $(this).appendTo(desktopWrapper);
        });
        mobileWrapper.html("");
    } else {
        $('.js-select-filter-wrap').each(function(){
            $(this).appendTo(mobileWrapper);
        });
        desktopWrapper.html("");
    }
}

runIfElementExist(transferDataTableFilters, '.js-data-table');
resizeTimer(transferDataTableFilters, '.js-data-table', 250);
